module.exports = __webpack_public_path__ + "static/media/Nvph2.a112f1a6.webp";